import axios from 'axios'

const instance = axios.create({
    baseURL: 'https://kanban-rafi.herokuapp.com'
  });

export default instance